module.exports = __webpack_public_path__ + "static/media/1AC0960E-893F-482B-9516-ACBA4403C5A3.4566691c.JPG";